import { LANGUAGES, TRADE_TYPES } from './campaignConstants'

export const filterEmptyValues = (obj) => {
  const filtered = {}
  Object.keys(obj).forEach(key => {
    const value = obj[key]
    if (value !== '' && value !== null && value !== undefined) {
      if (Array.isArray(value)) {
        if (value.length > 0) {
          filtered[key] = value
        }
      } else {
        filtered[key] = value
      }
    }
  })
  return filtered
}

export const extractSenderCompanyData = (val) => {
  const senderCompanySource = val.senderCompany && typeof val.senderCompany === 'object' && !Array.isArray(val.senderCompany)
    ? val.senderCompany
    : {
        name: val['senderCompany.name'],
        industry: val['senderCompany.industry'],
        country: val['senderCompany.country'],
        contact_person: val['senderCompany.contact_person'],
        contact_title: val['senderCompany.contact_title'],
        email: val['senderCompany.email'],
        key_products: val['senderCompany.key_products'],
        website: val['senderCompany.website'],
        phone: val['senderCompany.phone'],
        production_capacity: val['senderCompany.production_capacity'],
        facilities: val['senderCompany.facilities'],
        certifications: val['senderCompany.certifications'],
        market_experience: val['senderCompany.market_experience'],
        company_values: val['senderCompany.company_values']
      }

  return {
    name: senderCompanySource.name || '',
    industry: senderCompanySource.industry || '',
    country: senderCompanySource.country || '',
    contact_person: senderCompanySource.contact_person || '',
    contact_title: senderCompanySource.contact_title || '',
    email: senderCompanySource.email || '',
    key_products: senderCompanySource.key_products?.map(item => typeof item === 'string' ? item : item.value) || [],
    website: senderCompanySource.website || '',
    phone: senderCompanySource.phone || '',
    production_capacity: senderCompanySource.production_capacity || '',
    facilities: senderCompanySource.facilities?.map(item => typeof item === 'string' ? item : item.value) || [],
    certifications: senderCompanySource.certifications?.map(item => typeof item === 'string' ? item : item.value) || [],
    market_experience: senderCompanySource.market_experience?.map(item => typeof item === 'string' ? item : item.value) || [],
    company_values: senderCompanySource.company_values?.map(item => typeof item === 'string' ? item : item.value) || []
  }
}

export const extractEmailPurposeData = (val) => {
  const emailPurposeSource = val.emailPurpose && typeof val.emailPurpose === 'object' && !Array.isArray(val.emailPurpose)
    ? val.emailPurpose
    : {
        target_market: val['emailPurpose.target_market'],
        trade_type: val['emailPurpose.trade_type'],
        product_category: val['emailPurpose.product_category'],
        language: val['emailPurpose.language'],
        specific_products: val['emailPurpose.specific_products'],
        call_to_action: val['emailPurpose.call_to_action']
      }

  return {
    target_market: emailPurposeSource.target_market || '',
    trade_type: emailPurposeSource.trade_type || TRADE_TYPES.EXPORT,
    product_category: emailPurposeSource.product_category || '',
    language: emailPurposeSource.language || LANGUAGES.ENGLISH,
    specific_products: emailPurposeSource.specific_products?.map(item => typeof item === 'string' ? item : item.value) || [],
    call_to_action: emailPurposeSource.call_to_action || ''
  }
}

export const transformFormValuesToProfile = (currentValues, emailUserName = '') => {
  return {
    sender_company: {
      name: currentValues['senderCompany.name'] || '',
      industry: currentValues['senderCompany.industry'] || '',
      country: currentValues['senderCompany.country'] || '',
      contact_person: currentValues['senderCompany.contact_person'] || '',
      contact_title: currentValues['senderCompany.contact_title'] || '',
      email: currentValues['senderCompany.email'] || emailUserName,
      key_products: currentValues['senderCompany.key_products']?.map(item => typeof item === 'string' ? item : item.value) || [],
      website: currentValues['senderCompany.website'] || '',
      phone: currentValues['senderCompany.phone'] || '',
      production_capacity: currentValues['senderCompany.production_capacity'] || '',
      facilities: currentValues['senderCompany.facilities']?.map(item => typeof item === 'string' ? item : item.value) || [],
      certifications: currentValues['senderCompany.certifications']?.map(item => typeof item === 'string' ? item : item.value) || [],
      market_experience: currentValues['senderCompany.market_experience']?.map(item => typeof item === 'string' ? item : item.value) || [],
      company_values: currentValues['senderCompany.company_values']?.map(item => typeof item === 'string' ? item : item.value) || []
    },
    email_purpose: {
      target_market: currentValues['emailPurpose.target_market'] || '',
      trade_type: currentValues['emailPurpose.trade_type'] || TRADE_TYPES.EXPORT,
      product_category: currentValues['emailPurpose.product_category'] || '',
      language: currentValues['emailPurpose.language'] || LANGUAGES.ENGLISH,
      specific_products: currentValues['emailPurpose.specific_products']?.map(item => typeof item === 'string' ? item : item.value) || [],
      call_to_action: currentValues['emailPurpose.call_to_action'] || ''
    }
  }
}

export const createFormValuesFromProfile = (profile, emailSettings, getLocalizedCountryName) => {
  return {
    emailUserName: emailSettings?.emailUserName || '',
    emailPassword: emailSettings?.emailPassword || '',
    smtpHostName: emailSettings?.smtpHostName || '',
    smtpPort: emailSettings?.smtpPort || '',
    transportStrategy: emailSettings?.transportStrategy || '',
    rxHostName: emailSettings?.rxHostName || '',
    rxPort: emailSettings?.rxPort || '',
    rxProtocol: emailSettings?.rxProtocol || '',
    inboxFolderName: emailSettings?.inboxFolderName || '',
    productName: profile?.productName || [],
    productListOp: profile?.productListOp || 'or',
    'senderCompany.name': profile?.sender_company?.name || '',
    'senderCompany.industry': profile?.sender_company?.industry || '',
    'senderCompany.country': getLocalizedCountryName(profile?.sender_company?.country || ''),
    'senderCompany.contact_person': profile?.sender_company?.contact_person || '',
    'senderCompany.contact_title': profile?.sender_company?.contact_title || '',
    'senderCompany.email': profile?.sender_company?.email || emailSettings?.emailUserName || '',
    'senderCompany.key_products': profile?.sender_company?.key_products || [],
    'senderCompany.website': profile?.sender_company?.website || '',
    'senderCompany.phone': profile?.sender_company?.phone || '',
    'senderCompany.production_capacity': profile?.sender_company?.production_capacity || '',
    'senderCompany.facilities': profile?.sender_company?.facilities || [],
    'senderCompany.certifications': profile?.sender_company?.certifications || [],
    'senderCompany.market_experience': profile?.sender_company?.market_experience || [],
    'senderCompany.company_values': profile?.sender_company?.company_values || [],
    'emailPurpose.target_market': getLocalizedCountryName(profile?.email_purpose?.target_market || ''),
    'emailPurpose.trade_type': profile?.email_purpose?.trade_type || TRADE_TYPES.EXPORT,
    'emailPurpose.product_category': profile?.email_purpose?.product_category || '',
    'emailPurpose.language': profile?.email_purpose?.language || LANGUAGES.ENGLISH,
    'emailPurpose.specific_products': profile?.email_purpose?.specific_products || [],
    'emailPurpose.call_to_action': profile?.email_purpose?.call_to_action || ''
  }
}
